import { request } from "../../Base/HTTP";

export async function getCurrencies() {
  return await request("/api/currencies/get_list");
}

export async function getAllCurrencies() {
  return await request("/api/currencies/all");
}
